import createApiCall from './endpoints'

export const getPassword = (nonce, data) => createApiCall({
    apiEndpoint: 'GET_PASSWORD',
    nonce: nonce,
    data: data
})